"use strict";

import _ from "lodash";

class WordpressRemover {
  /**
   * Removes the 'wp' property from the page and its blocks.  This mutates the page
   * @param page - a javascript object
   * @returns {Object}
   */
  static removeFromPage(/** Object **/ page) {
    if (_.has(page, "blockData")) {
      page.blockData = _.mapValues(page.blockData, WordpressRemover.removeFromBlock);
    }

    page = WordpressRemover.removeProperty(page);

    return page;
  }

  /**
   * Removes the 'wp' property from the block and its elements.  This mutates the block
   * @param block - a javascript object
   * @returns {Object}
   */
  static removeFromBlock(/** Object **/ block) {
    if (_.has(block, "elements")) {
      block.elements = _.map(block.elements, WordpressRemover.removeProperty);
    }

    if (_.has(block, "states")) {
      _.forEach(block.states, function (state) {
        if (_.has(state, "elements")) {
          state.elements = _.map(state.elements, WordpressRemover.removeProperty);
        }
      });
    }

    block = WordpressRemover.removeProperty(block);

    return block;
  }

  /**
   * Removes the 'wp' property from the item.  This mutates the item
   * @param item
   * @returns {Object}
   */
  static removeProperty(/** Object **/ item) {
    if (_.has(item, "wp")) {
      _.unset(item, "wp");
    }

    return item;
  }
}

export default WordpressRemover;
